var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"pdg-"},[_c('ul',{staticClass:"list-stacked list-stacked--tiny"},_vm._l((_vm.categories),function(category,i){return _c('li',{key:i},[_c('NavItem',{attrs:{"category":category}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }